import { useEffect, useRef, useState } from "react";
import "./meetingdetails.css";
import Header from "./Header";
import Detailssection from "./Detailssection";
import momsection from "../../assets/notch_mom_yellow.png";
import MomDrawer from "./Meetingdrawer";
import Actionstate from "./Actionstate";
import Hexapi from "../../utility/HexAPI/Hexapi";
import MeetingQRScanner from "./MeetingQRScanner";
import { showConfirm } from "../../utility/showconfirm";
import { Modal, Spinner } from "react-bootstrap";
import Loader from "../../components/loader/Loader";
import { RSVP } from "./Rsvp";
import Editmeeting from "./addmeeting/Editmeeting";
import { showCustomSwal } from "../../components/customswal/Customswal";


const Meetingdetails = ({
  userid,
  setisInfo,
  meetingInfo,
  meetingAction,
  attachments,
  GetMeetingDetails,
  getMeetingListData
}) => {
  const [showMom, setShowMom] = useState(false);
  const [showScanner, setShowScanner] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showbottom, setShowBottom] = useState(false);
  const [show,setshow]=useState(false)
  const resvpref=useRef(null)
  const actionstateref=useRef(null)
const [bottomHeight, setBottomHeight] = useState(0);

const handleleaveMeeting = async (query, queryArr) => {

  try {
    setLoading(true);
    const resp = await Hexapi({ query, queryArr });
    if (resp?.[""]?.[0]?.command == 1) {
      GetMeetingDetails(true);
      getMeetingListData(true);
    } else if (resp?.[""]?.[0]?.command == 0) {
      showConfirm({ content: resp?.[""]?.[0]?.msg, hideCancel: false });
    }
  } catch (err) {
     if(err.message =="SQL Error occurred"){
            showCustomSwal("error occurred please try again")
            return;
          }
    showConfirm({ content: "Something went wrong. Please try again.", hideCancel: true });
  } finally {
    setLoading(false);
  }
}
useEffect(() => {
  const updateHeight = () => {
    let height = 0;

    if (resvpref.current) {
      height += resvpref.current.offsetHeight;
    }

    if (actionstateref.current) {
      height += actionstateref.current.offsetHeight;
    }
    setBottomHeight(height);
  };

  updateHeight();

  const observer = new ResizeObserver(updateHeight);

  if (resvpref.current) observer.observe(resvpref.current);
  if (actionstateref.current) observer.observe(actionstateref.current);

  return () => observer.disconnect();
}, [meetingInfo]);
  const executeQuery = async (query, queryArr, successCallback) => {
    try {
      setLoading(true);
      const resp = await Hexapi({ query, queryArr });
      if (resp?.[""]?.[0]?.command == 1) {
        setLoading(false);
        successCallback?.();
      } else if (resp?.[""]?.[0]?.command == 0) {
        showConfirm({ content: resp?.[""]?.[0]?.msg, hideCancel: false });
      }
    } catch (err) {
      // console.error("API error:", err);
       if(err.message =="SQL Error occurred"){
            showCustomSwal("error occurred please try again")
            return;
          }
      showConfirm({ content: "Something went wrong. Please try again.", hideCancel: true });
    } finally {
      setLoading(false);
    }
  };


  const handleQRJoin = async (MeetingQR) => {
    if (!MeetingQR) return;
    setShowScanner(false);

    let meetingData;
    try {
      meetingData = atob(MeetingQR);
    } catch (err) {
      await showConfirm({
        content:`Invalid QR Code:, ${err}`
      })
     
      return;
    }

    const query = `HRApp_Droid_Proc_User_Meeting_Join @UserID='{0}',@MeetingQR='{1}'`;
    await executeQuery(query, [userid, meetingData], () => {
      GetMeetingDetails(true);
      getMeetingListData(true);
    });
  };

      const isMomVisible =
  String(meetingInfo?.mom) !== "-1" &&
  String(meetingInfo?.stage) !== "0" &&
  String(meetingInfo?.stage) !== "-1";

  const handleMeetingAction = async (query, queryArr, type) => {
    // console.log(query, queryArr,type,"fhgdhjkws")
    switch (type) {
      case "REQUEST_START_MEETING":
      case "REQUEST_END_MEETING":
   
        await executeQuery(query, queryArr, () => {
          GetMeetingDetails(true);
          getMeetingListData(true);
        });
        break;
   case "REQUEST_LEAVE_MEETING":
      handleleaveMeeting(query, queryArr);
      break;
      case "REQUEST_JOIN_MEETING":
        setShowScanner(true);
        break;
      case "REQUEST_RESCHEDULE_MEETING":
        setshow(true)
        break;
      default:
        console.warn("Unknown action type:", type);
    }
  };

  return (
    <div className="meetingdetails">
      <div className="meetingdetailinfo" style={{ position: "relative" , backgroundColor:"#faf9fb" }}>
        <Header info={meetingInfo} onClick={() => setisInfo(true)} />

      {loading && (
  <div className="meeting-loader">
    <Loader />
  </div>
)}

        {meetingAction?.length > 0 && (
          <Detailssection
            bottomHeight={bottomHeight}
            userID={userid}
            meetingInfo={meetingInfo}
            details={meetingAction}
          />
        )}

 
{isMomVisible && (
  <div className="momsection" onClick={() => setShowMom(true)}>
    <img src={momsection} className="img-fluid" alt="MOM Section" />
  </div>
)}

  {(meetingInfo?.allowrsvpyes != null &&
    (meetingInfo?.allowrsvpyes != 0 || meetingInfo?.allowrsvpno != 0)) && (
    <RSVP
      ref={resvpref}
      showbottom={showbottom}
      GetMeetingDetails={GetMeetingDetails}
      meetingID={meetingInfo?.meetingid}
      userID={userid}
      curRSVPAction={meetingInfo?.currsvpaction}
    />
  )}

  <Actionstate
  setShowBottom={setShowBottom}
    ref={actionstateref}
    meetingInfo={meetingInfo}
    userID={userid}
    onActionClick={handleMeetingAction}
  />

        <MomDrawer
          attachments={attachments}
          showMom={showMom}
          setShowMom={setShowMom}
          mominfo={meetingInfo}
          userid={userid}
          GetMeetingDetails={GetMeetingDetails}
        />

        {showScanner && (
          <MeetingQRScanner
            userid={userid}
            show={showScanner}
            onJoin={handleQRJoin}
            onClose={() => setShowScanner(false)}
          />
        )}

{
  show && <Editmeeting isrescheduled={true} iscategory={false} getMeetingListData={getMeetingListData} GetMeetingDetails meetingInfo={meetingInfo} show={show} hide={()=>setshow(false)}/>
}
            
      </div>
    </div>
  );
};

export default Meetingdetails;